import { render, staticRenderFns } from "./PeasantsStrive.vue?vue&type=template&id=7710143e"
import script from "./PeasantsStrive.vue?vue&type=script&lang=js"
export * from "./PeasantsStrive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports